import "./BillOfMaterials.css";
import React, { useEffect, useState, useRef, useMemo } from "react";
import Select from "react-select";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useCookies } from "react-cookie";
import { useDataLayerValue } from "../../../App/reducer/DataLayer";
import CreatableSelect from "react-select/creatable";
import {
  useHistory,
  useParams,
  useLocation,
  useRouteMatch,
} from "react-router-dom";
import {
  ModalQuestion,
  ModalForm,
} from "../../../App/components/shared/Modals";
import _ from "lodash";
import { faInfoCircle, faTrash, faCalculator, faSync, faFilePdf, faFileExcel, faCopy, faArrowLeft, faCog, faUpload, faList, faMoneyBillWave, faCopy as faCopyAlt, faBox, faExclamationTriangle, faTimes, faSave, faHistory, faGripVertical } from "@fortawesome/free-solid-svg-icons";
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import DialogActions from "@material-ui/core/DialogActions";
import { faEdit } from "@fortawesome/free-regular-svg-icons";
import Loading from "../../../App/components/Loading/Loading";
import TableHeader from "../../../App/components/shared/TableHeader";
import fetch_backend from "../../../App/components/shared/Fetch";
import StatusBadge from "../../../App/components/shared/StatusBadge";
import {
  styles_react_select,
  styles_react_select_cost_centers,
} from "../../../App/components/shared/Select";
import { url_bill_of_materials, url_bom_products } from "../../constants/constants";
import { response_get_mock, response_project_info_mock, response_history_mock, response_history_results_mock, response_bom_detail_mock} from "./responses_mock";
import HistoryTab from "./HistoryTab";
import ProductsTab from "./ProductsTab";

const SectionDivider = ({ title, count, subtotal, formatCurrency, totalHours }) => (
  <div className="section-divider">
    <div className="section-divider-header">
      <div>
        <span className="section-divider-title">{title}</span>
        <span className="section-divider-subtitle">
          {count} {count === 1 ? 'elemento' : 'elementos'}
          {totalHours != null && ` • ${totalHours} ${totalHours === 1 ? 'hora' : 'horas'}`}
          {' • '}Subtotal: {formatCurrency(subtotal)}
        </span>
      </div>
    </div>
  </div>
);

const initialRowState = {
  isNew: true,
  id: null,
  code: { label: "", value: "" },
  description: { label: "", value: "" },
  unit: "",
  quantity: 0,
  unitValue: 0,
  totalValue: 0,
  recargo: 1,
  updateDate: new Date().toISOString().split('T')[0],
  info: "",
};

function BillOfMaterials() {
  const history = useHistory();
  const { path } = useRouteMatch();
  const [{ }, dispatch] = useDataLayerValue();
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const queryBomId = queryParams.get('bom_id');
  const queryMode = queryParams.get('mode');
  const queryIsProduct = queryParams.get('is_product') === '1';
  const { is_edit, is_new, bom_id, is_product: is_product_initial } = queryBomId
    ? { is_edit: true, is_new: false, bom_id: parseInt(queryBomId), is_product: queryIsProduct }
    : (location.state || { is_edit: false, is_new: true, bom_id: null, is_product: false });
  const isReadOnly = queryMode === 'view';
  const [isProductMode, setIsProductMode] = useState(is_product_initial || false);

  const [isLoading, setIsLoading] = useState(false);
  const [selectedOptions, setSelectedOptions] = useState({ order_name: "" });
  const [successfulOrderCreation, setSuccessfulOrderCreation] = useState(false);
  
  const [materials, setMaterials] = useState([]);
  const [labors, setLabors] = useState([]);
  const [costs, setCosts] = useState([]);
  const [containers, setContainers] = useState([]);
  
  const [materialOptions, setMaterialOptions] = useState({ codes: [], descriptions: [] });
  const [laborOptions, setLaborOptions] = useState({ codes: [], descriptions: [] });
  const [containerOptions, setContainerOptions] = useState({ codes: [], descriptions: [] });
  const [costOptions, setCostOptions] = useState({ codes: [], descriptions: [] });

  const [openModalForm, setOpenModalForm] = useState(false);
  const [successModalForm, setSuccessModalForm] = useState(false);
  const [messageModalForm, setMessageModalForm] = useState();
  const [cookies] = useCookies();
  const token = cookies.token_orders;
  const [currentDate] = useState(new Date().toLocaleDateString('es-ES'));
  const [editingUnitValue, setEditingUnitValue] = useState(null);
  const [adminPercentage, setAdminPercentage] = useState(10);
  const [contingencyPercentage, setContingencyPercentage] = useState(3);
  const [ivaPercentage, setIvaPercentage] = useState(19);
  const [utilityPercentage, setUtilityPercentage] = useState(29);
  const [containerUtilityPercentage, setContainerUtilityPercentage] = useState(15);
  const [lastSubtotalRange, setLastSubtotalRange] = useState('');
  const [trmValue, setTrmValue] = useState("");
  const [activeTab, setActiveTab] = useState('item-por-item');

  // Estado de la hoja tal como lo resuelve el backend. Solo para pintar el
  // badge: nunca se calcula ni se deduce aquí.
  const [bomColor, setBomColor] = useState(null);
  const [bomStatusLabel, setBomStatusLabel] = useState(null);
  // Elección del usuario al guardar ("draft" | "saved"). Preselecciona el
  // botón de guardado. Nunca alimenta el badge.
  const [internalStatus, setInternalStatus] = useState("draft");

  const [projectInfoModal, setProjectInfoModal] = useState(false);
  const [projectInfoSaved, setProjectInfoSaved] = useState(false);
  const [billOfMaterialsId, setBillOfMaterialsId] = useState(null);
  const [projectInfoLoading, setProjectInfoLoading] = useState(false);
  const [clientOptions, setClientOptions] = useState([]);
  const [quoteOptions, setQuoteOptions] = useState([]);
  const [tagOptions, setTagOptions] = useState([]);
  const [quoteItemOptions, setQuoteItemOptions] = useState([]);
  const [selectedClient, setSelectedClient] = useState(null);
  const [selectedQuote, setSelectedQuote] = useState(null);
  const [selectedQuoteItems, setSelectedQuoteItems] = useState(null);
  const [selectedTags, setSelectedTags] = useState([]);
  const [projectName, setProjectName] = useState("");
  const [projectDescription, setProjectDescription] = useState("");
  const [filteredQuotes, setFilteredQuotes] = useState([]);

  // Product Info (for isProductMode)
  const [productInfoModal, setProductInfoModal] = useState(false);
  const [productInfoSaved, setProductInfoSaved] = useState(false);
  const [productInfoLoading, setProductInfoLoading] = useState(false);
  const [sizeTagOptions, setSizeTagOptions] = useState([]);
  const [allProducts, setAllProducts] = useState([]);
  const [selectedSize, setSelectedSize] = useState(null);
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [productDescription, setProductDescription] = useState("");


  const [infoModal, setInfoModal] = useState({ open: false, section: null, index: null });
  const [infoNotes, setInfoNotes] = useState("");
  const [infoNewFiles, setInfoNewFiles] = useState([]);
  const [infoExistingAttachments, setInfoExistingAttachments] = useState([]);
  const [infoDragActive, setInfoDragActive] = useState(false);
  const [infoSaving, setInfoSaving] = useState(false);
  const [infoNotesEditing, setInfoNotesEditing] = useState(false);
  const infoFileInputRef = useRef(null);
  const infoNotesTextareaRef = useRef(null);
  // Catálogo de opciones de costos (bill_materials/options/). Es la fuente de
  // verdad del sum_from de cada ítem, porque el backend no lo persiste en las
  // filas guardadas de la hoja.
  const costCatalogRef = useRef([]);

  // Drag-and-drop para reordenar Materiales (solo en hojas nuevas).
  // El arrastre se habilita solo desde el "grip" para no interferir con los inputs de la fila.
  const canReorderMaterials = is_new && !isReadOnly;
  const [materialDragEnabled, setMaterialDragEnabled] = useState(false);
  const [materialDragIndex, setMaterialDragIndex] = useState(null);
  const [materialDragOverIndex, setMaterialDragOverIndex] = useState(null);

  const handleMaterialDragStart = (index) => {
    setMaterialDragIndex(index);
  };

  const handleMaterialDragOver = (event, index) => {
    event.preventDefault();
    if (index !== materialDragOverIndex) setMaterialDragOverIndex(index);
  };

  const handleMaterialDrop = (index) => {
    const from = materialDragIndex;
    if (from != null && from !== index) {
      setMaterials(prev => {
        const updated = [...prev];
        const [moved] = updated.splice(from, 1);
        updated.splice(index, 0, moved);
        return updated;
      });
    }
    handleMaterialDragEnd();
  };

  const handleMaterialDragEnd = () => {
    setMaterialDragEnabled(false);
    setMaterialDragIndex(null);
    setMaterialDragOverIndex(null);
  };

  const styles_multi_select = {
    ...styles_react_select,
    control: (styles) => ({
      ...styles,
      fontFamily: "Roboto, sans-serif",
      borderWidth: 1,
      minHeight: "38px",
      height: "auto",
      borderRadius: "5px",
      width: "100%",
    }),
    valueContainer: (provided) => ({
      ...provided,
      height: "auto",
      maxHeight: "120px",
      overflowY: "auto",
      padding: "4px 6px",
      flexWrap: "wrap",
    }),
    input: (provided) => ({
      ...provided,
      margin: "0",
      fontSize: "13px",
    }),
  };

  const formatCurrency = (value) => {
    return new Intl.NumberFormat('es-CO', {
      style: 'currency',
      currency: 'COP',
      minimumFractionDigits: 0,
      maximumFractionDigits: 0
    }).format(value);
  };

  const parseCurrency = (value) => {
    return parseFloat(value.replace(/[^0-9.-]+/g, ''));
  };

  const handleUnitValueChange = (index, value, section) => {
    const sectionState = getSectionState(section);
    const setSectionState = getSectionSetter(section);
    let tableRows_ = [...sectionState];
    const numericValue = value ? parseCurrency(value) : 0;
    tableRows_[index]["unitValue"] = numericValue;
    const qty = section === 'costs' ? 1 : (tableRows_[index]["quantity"] || 0);
    const recargo = section === 'labors' ? (tableRows_[index]["recargo"] || 1) : 1;
    tableRows_[index]["totalValue"] = numericValue * qty * recargo;
    setSectionState(tableRows_);
  };

  const handleUnitValueFocus = (index) => {
    setEditingUnitValue(index);
  };

  const handleUnitValueBlur = (index) => {
    setEditingUnitValue(null);
  };

  const getSubtotalAdaptation = () => {
    const items = [...materials, ...labors, ...costs];
    return items.reduce((acc, row) => acc + (row.totalValue || 0), 0);
  };

  const getSubtotalContainers = () => {
    return containers.reduce((acc, row) => acc + (row.totalValue || 0), 0);
  };

  const getSubtotal = () => {
    return getSubtotalAdaptation() + getSubtotalContainers();
  }

  const getSubtotalRange = (subtotal) => {
    if (subtotal < 50000000) return 'low';
    if (subtotal >= 50000000 && subtotal < 100000000) return 'medium';
    return 'high';
  };

  useEffect(() => {
    const subtotal = getSubtotal();
    const currentRange = getSubtotalRange(subtotal);
    
    if (is_new && currentRange !== lastSubtotalRange) {
      if (subtotal < 50000000) {
        setUtilityPercentage(29);
        setAdminPercentage(10);
        setContingencyPercentage(3);
      } else if (subtotal >= 50000000 && subtotal < 100000000) {
        setUtilityPercentage(27);
        setAdminPercentage(8);
        setContingencyPercentage(2);
      } else if (subtotal >= 100000000) {
        setUtilityPercentage(25);
        setAdminPercentage(6);
        setContingencyPercentage(2);
      }
      setLastSubtotalRange(currentRange);
    }
  }, [materials, labors, costs, containers, is_new, lastSubtotalRange]);

  // Las filas de costo porcentuales ya no se sincronizan por efecto: su base y
  // total se calculan derivados en el render (ver computeCostRowValues), por lo que
  // siempre reflejan las sumas actuales de Materiales / Mano de Obra / Contenedores.

  useEffect(() => {
    dispatch({
      type: "SET_URL",
      actual_url: path,
    });
    send_init_request();
  }, []);

  const getSectionState = (section) => {
    if (section === 'materials') return materials;
    if (section === 'labors') return labors;
    if (section === 'costs') return costs;
    if (section === 'containers') return containers;
  };

  const getSectionSetter = (section) => {
    if (section === 'materials') return setMaterials;
    if (section === 'labors') return setLabors;
    if (section === 'costs') return setCosts;
    if (section === 'containers') return setContainers;
  };

  const getSectionOptions = (section) => {
    if (section === 'materials') return materialOptions;
    if (section === 'labors') return laborOptions;
    if (section === 'containers') return containerOptions;
    if (section === 'costs') return costOptions;
    return {};
  }

  const getSectionSumBySumFrom = (sumFrom) => {
    if (sumFrom === 'materiales') return materials.reduce((acc, row) => acc + (row.totalValue || 0), 0);
    if (sumFrom === 'mano_obra') return labors.reduce((acc, row) => acc + (row.totalValue || 0), 0);
    if (sumFrom === 'contenedores') {
      const usdSum = containers.reduce((acc, row) => acc + (row.totalValue || 0), 0);
      return usdSum * (trmValue || 0);
    }
    if (sumFrom === 'total') {
      const materialsSum = materials.reduce((acc, row) => acc + (row.totalValue || 0), 0);
      const laborsSum = labors.reduce((acc, row) => acc + (row.totalValue || 0), 0);
      const containersUsdSum = containers.reduce((acc, row) => acc + (row.totalValue || 0), 0);
      return materialsSum + laborsSum + containersUsdSum * (trmValue || 0);
    }
    return 0;
  };

  // Recupera el sum_from de un ítem de costo desde el catálogo de opciones,
  // emparejando por descripción (los ids guardados no coinciden con los del
  // catálogo). Devuelve null si no se encuentra.
  const lookupSumFromInCatalog = (description) => {
    if (!description) return null;
    const opt = (costCatalogRef.current || []).find(o => o.description === description);
    return opt ? (opt.sum_from || null) : null;
  };

  // Para las filas de costo porcentuales (unit === '%' con sum_from) la base y el
  // total son SIEMPRE derivados de las sumas actuales de las secciones; no se leen
  // de los valores guardados en la fila (que pueden quedar desactualizados). Para
  // las filas de valor fijo se conservan los valores tal cual.
  const computeCostRowValues = (row) => {
    if (row.unit === '%' && row.sum_from) {
      const base = getSectionSumBySumFrom(row.sum_from);
      return {
        unitValue: base,
        totalValue: base * (row.percentage || 0) / 100,
      };
    }
    return { unitValue: row.unitValue || 0, totalValue: row.totalValue || 0 };
  };

  const handleCostPercentageChange = (index, percentageValue) => {
    // Solo se guarda el porcentaje (el input real); la base y el total se derivan
    // en el render a partir de las sumas actuales via computeCostRowValues.
    setCosts(prev => prev.map((row, i) =>
      i === index ? { ...row, percentage: percentageValue } : row
    ));
  };

  const openInfoModal = (section, index) => {
    const row = getSectionState(section)[index];
    setInfoNotes(row.info || "");
    setInfoExistingAttachments(row.attachments || []);
    setInfoNewFiles([]);
    setInfoDragActive(false);
    setInfoModal({ open: true, section, index });
  };

  const closeInfoModal = () => {
    setInfoModal({ open: false, section: null, index: null });
    setInfoNotes("");
    setInfoNewFiles([]);
    setInfoExistingAttachments([]);
    setInfoDragActive(false);
  };

  const handleInfoDragOver = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setInfoDragActive(true);
  };

  const handleInfoDragLeave = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setInfoDragActive(false);
  };

  const handleInfoDrop = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setInfoDragActive(false);
    const files = Array.from(e.dataTransfer.files).filter(f => f.type.startsWith('image/'));
    setInfoNewFiles(prev => [...prev, ...files]);
  };

  const handleInfoFileInput = (e) => {
    const files = Array.from(e.target.files).filter(f => f.type.startsWith('image/'));
    setInfoNewFiles(prev => [...prev, ...files]);
    e.target.value = '';
  };

  const removeNewFile = (index) => {
    setInfoNewFiles(prev => prev.filter((_, i) => i !== index));
  };

  const removeExistingAttachment = (index) => {
    setInfoExistingAttachments(prev => prev.filter((_, i) => i !== index));
  };

  const linkifyText = (text) => {
    if (!text) return null;
    const urlRegex = /(https?:\/\/[^\s]+)/g;
    return text.split(urlRegex).map((part, i) => {
      if (part.match(/^https?:\/\//)) {
        return <a key={i} href={part} target="_blank" rel="noopener noreferrer" className="info-link">{part}</a>;
      }
      return part.split('\n').map((line, j, arr) => (
        <React.Fragment key={`${i}-${j}`}>
          {line}
          {j < arr.length - 1 && <br />}
        </React.Fragment>
      ));
    });
  };

  const saveItemInfo = async () => {
    const { section, index } = infoModal;
    if (section === null || index === null) return;

    setInfoSaving(true);

    // Update local row state
    const sectionState = getSectionState(section);
    const setSectionState = getSectionSetter(section);
    let rows = [...sectionState];
    rows[index] = {
      ...rows[index],
      info: infoNotes,
      attachments: infoExistingAttachments,
    };
    setSectionState(rows);

    // Send to backend
    const itemId = rows[index].id;
    try {
      const formData = new FormData();
      formData.append('bill_of_materials_id', billOfMaterialsId || '');
      formData.append('section', section);
      formData.append('item_id', itemId || '');
      formData.append('notes', infoNotes);
      formData.append('existing_attachment_ids', JSON.stringify(infoExistingAttachments.map(a => a.id)));
      infoNewFiles.forEach(file => formData.append('attachments', file));

      await fetch_backend("bill_materials/item_info/", "POST", token, dispatch, formData);
    } catch (error) {
      console.error("Failed to save item info", error);
    }

    setInfoSaving(false);
    closeInfoModal();
  };

  const [trmLoading, setTrmLoading] = useState(false);

  async function fetchTrm() {
    setTrmLoading(true);
    try {
      const now = new Date();
      const bogotaOffset = now.toLocaleString("en-US", { timeZone: "America/Bogota" });
      const bogotaDate = new Date(bogotaOffset);
      const today = bogotaDate.toISOString().split("T")[0];

      let response = await fetch(
        `https://www.datos.gov.co/resource/32sa-8pi3.json?$where=vigenciadesde='${today}T00:00:00.000'&$limit=1`
      );
      let data = await response.json();

      if (!data || data.length === 0) {
        response = await fetch(
          `https://www.datos.gov.co/resource/32sa-8pi3.json?$order=vigenciadesde DESC&$limit=1`
        );
        data = await response.json();
      }

      if (data && data.length > 0) {
        const valor = parseFloat(data[0].valor);
        if (!isNaN(valor)) {
          setTrmValue(Math.round((valor + 50) * 100) / 100);
        }
      }
    } catch (error) {
      console.error("Error al consultar TRM:", error);
    } finally {
      setTrmLoading(false);
    }
  }

  async function send_init_request() {
    setIsLoading(true);
    // Assuming a generic endpoint for initial data
    const url = `bill_materials/options/`;
    let preloadedCosts = [];
    try {
      const response = await fetch_backend(url, "GET", token, dispatch);
      // const response = { data: response_get_mock, status: 200 }; // Mocked response
      if (response && response.status === 200) {
        setMaterialOptions(buildOptions(response.materials));
        setLaborOptions(buildOptions(response.labors));
        setContainerOptions(buildOptions(response.containers));
        setCostOptions(buildOptions(response.costs));
        costCatalogRef.current = response.costs || [];
        preloadedCosts = buildAlwaysVisibleCostRows(response.costs);
      }
    } catch (error) {
      console.error("Failed to fetch initial data", error)
    } finally {
      setIsLoading(false);
    }

    // Auto-cargar TRM al iniciar
    fetchTrm();

    if (!is_new && bom_id) {
      await loadBomDetail(bom_id);
    } else {
      setMaterials([]);
      setLabors([]);
      setCosts(preloadedCosts);
      setContainers([]);
    }
  }

  // Punto único donde se aplica el estado que manda el backend, tanto en las
  // lecturas (color / status_label) como en las escrituras (bom_color /
  // bom_status_label). Nada de esto se deduce en el front.
  const applyBomStatus = (response, { read }) => {
    if (!response) return;
    const color = read ? response.color : response.bom_color;
    const label = read ? response.status_label : response.bom_status_label;
    // OJO: en las lecturas fetch_backend pisa response.status con el código
    // HTTP, así que el estado solo viaja en color / status_label.
    if (label !== undefined) {
      setBomColor(color ?? null);
      setBomStatusLabel(label ?? null);
    }
    if (response.internal_status) {
      setInternalStatus(response.internal_status);
    }
  };

  const loadBomDetail = async (id) => {
    setIsLoading(true);
    try {
      const endpoint = isProductMode ? `product_quote_price/${id}/` : `bill_materials/${id}/`;
      const response = await fetch_backend(endpoint, "GET", token, dispatch);
      // const response = { ...response_bom_detail_mock, status: 200 }; // Mocked response
      if (response && response.status === 200) {
        const mapRows = (items, section) => (items || []).map(item => ({
          isNew: false,
          id: item.id,
          code: item.code ? { value: item.code, label: `${item.code}` } : { value: "", label: "" },
          description: item.description ? { value: item.id || item.description, label: item.description } : { value: "", label: "" },
          unit: item.unit || "",
          quantity: parseFloat(item.quantity) || 0,
          unitValue: parseFloat(item.unit_value) || 0,
          totalValue: parseFloat(item.total_value) || 0,
          recargo: section === 'labors' ? (parseFloat(item.recargo) || 1) : 1,
          updateDate: item.update_date || "",
          info: item.notes || item.info || "",
          attachments: item.attachments || [],
          code_material: item.code_material || null,
        }));
        const mapCostRows = (items) => (items || []).map(item => ({
          isNew: false,
          id: item.id,
          description: item.description ? { value: item.id || item.description, label: item.description } : { value: "", label: "" },
          unit: item.unit || "",
          quantity: 1,
          unitValue: parseFloat(item.unit_value) || 0,
          totalValue: parseFloat(item.total_value) || 0,
          info: item.notes || item.info || "",
          attachments: item.attachments || [],
          sum_from: item.sum_from || lookupSumFromInCatalog(item.description),
          percentage: parseFloat(item.percentage) || null,
        }));
        // Se muestran en el orden que envía el backend, sin reordenar.
        setMaterials(mapRows(response.materials, 'materials'));
        setLabors(mapRows(response.labors, 'labors'));
        setCosts(mapCostRows(response.costs));
        setContainers(mapRows(response.containers, 'containers'));

        if (response.percentages) {
          setAdminPercentage(response.percentages.admin ?? 10);
          setContingencyPercentage(response.percentages.contingency ?? 3);
          setUtilityPercentage(response.percentages.utility_adaptation ?? response.percentages.utility ?? 29);
          setContainerUtilityPercentage(response.percentages.utility_container ?? 15);
          setIvaPercentage(response.percentages.iva ?? 19);
        }
        if (response.trm_value) setTrmValue(response.trm_value);
        if (response.project_info) {
          setProjectInfoSaved(true);
          const pi = response.project_info;
          if (pi.name) {
            setProjectName(pi.name);
          }
          if (pi.client_id) {
            setSelectedClient({ value: pi.client_id, label: pi.client_name || "" });
          }
          if (pi.quote_id) {
            setSelectedQuote({ value: pi.quote_id, label: `Cotización #${pi.quote_id}` });
          }
          if (pi.quote_items && pi.quote_items.length > 0) {
            const firstQi = pi.quote_items[0];
            setSelectedQuoteItems({ value: firstQi, label: `Item #${firstQi}` });
          }
          if (pi.tags && pi.tags.length > 0) {
            setSelectedTags(pi.tags.map(t => ({ value: t, label: `Tag #${t}` })));
          }
          if (pi.description) {
            setProjectDescription(pi.description);
          }
        }
        const pri = response.product_info || {
          size_id: response.product_size ?? response.size_id,
          product_id: response.product_id ?? (isProductMode ? id : null),
          product_name: response.product_name,
          description: response.product_description ?? response.description,
        };
        if (isProductMode || response.product_info) {
          setProductInfoSaved(true);
          if (pri.size_id) {
            setSelectedSize({ value: pri.size_id, label: `Tamaño #${pri.size_id}` });
          }
          if (pri.product_id) {
            setSelectedProduct({
              value: pri.product_id,
              label: pri.product_name || `Producto #${pri.product_id}`,
              description: pri.description || "",
            });
          }
          setProductDescription(pri.description || "");
        }
        setSelectedOptions({ order_name: response.order_name || "" });
        applyBomStatus(response, { read: true });
        setBillOfMaterialsId(id);
        setActiveTab('item-por-item');
      }
    } catch (error) {
      console.error("Failed to load BOM detail", error);
    } finally {
      setIsLoading(false);
    }
  };

  const openProjectInfoModal = async () => {
    setProjectInfoModal(true);
    setProjectInfoLoading(true);
    try {
      const response = await fetch_backend("bill_materials/project_info/options/", "GET", token, dispatch);
      // const response = { ...response_project_info_mock, status: 200 }; // Mocked response
      if (response && response.status === 200) {
        const clientOpts = (response.clients || []).map(c => ({ value: c.id, label: c.name }));
        const quoteOpts = (response.quotes || []).map(q => ({ value: q.id, label: `Cotización #${q.id}`, client_id: q.client_id }));
        const tagOpts = (response.tags || []).map(t => ({ value: t.id, label: t.name }));
        setClientOptions(clientOpts);
        setQuoteOptions(quoteOpts);
        setTagOptions(tagOpts);

        // Update labels for pre-selected values (when editing existing BOM)
        if (selectedClient) {
          const found = clientOpts.find(c => c.value === selectedClient.value);
          if (found) setSelectedClient(found);
          setFilteredQuotes(quoteOpts.filter(q => q.client_id === selectedClient.value));
        }
        if (selectedQuote) {
          const found = quoteOpts.find(q => q.value === selectedQuote.value);
          if (found) setSelectedQuote(found);
        }
        if (selectedTags.length > 0) {
          const updatedTags = selectedTags.map(st => {
            const found = tagOpts.find(t => t.value === st.value);
            return found || st;
          });
          setSelectedTags(updatedTags);
        }
        // Load quote items if quote is selected
        if (selectedQuote && selectedQuoteItems) {
          try {
            const itemsResponse = await fetch_backend(`quote/${selectedQuote.value}/items`, "GET", token, dispatch);
            if (itemsResponse && itemsResponse.status === 200) {
              const allItems = (itemsResponse.items || []).map(item => ({
                value: item.id,
                label: `${item.description} - ${item.product}`,
              }));
              setQuoteItemOptions(allItems);
              const found = allItems.find(ai => ai.value === selectedQuoteItems.value);
              setSelectedQuoteItems(found || selectedQuoteItems);
            }
          } catch (e) {
            console.error("Failed to load quote items for existing BOM", e);
          }
        }
      }
    } catch (error) {
      console.error("Failed to fetch project info options", error);
    } finally {
      setProjectInfoLoading(false);
    }
  };

  const handleClientChange = (option) => {
    setSelectedClient(option);
    setSelectedQuote(null);
    setSelectedQuoteItems(null);
    setQuoteItemOptions([]);
    if (option) {
      setFilteredQuotes(quoteOptions.filter(q => q.client_id === option.value));
    } else {
      setFilteredQuotes([]);
    }
  };

  const handleQuoteChange = async (option) => {
    setSelectedQuote(option);
    setSelectedQuoteItems(null);
    setQuoteItemOptions([]);
    if (!option) return;

    try {
      const response = await fetch_backend(`quote/${option.value}/items`, "GET", token, dispatch);
      if (response && response.status === 200) {
        const items = (response.items || []).map(item => ({
          value: item.id,
          label: `${item.description} - ${item.product}`,
        }));
        setQuoteItemOptions(items);
      }
    } catch (error) {
      console.error("Failed to fetch quote items", error);
    }
  };

  const saveProjectInfo = async () => {
    if (!selectedClient || selectedTags.length === 0) {
      setSuccessModalForm(false);
      setMessageModalForm("Debe seleccionar al menos Cliente y Tag.");
      setOpenModalForm(true);
      return;
    }

    // En edición se envía el id del BOM para que el backend actualice el existente
    // en lugar de crear uno nuevo. En creación no se manda el campo.
    const currentBomId = billOfMaterialsId || bom_id || null;

    const payload = {
      name: projectName,
      client_id: selectedClient.value,
      quote_id: selectedQuote?.value || null,
      quote_items: selectedQuoteItems ? [selectedQuoteItems.value] : [],
      tags: selectedTags.map(t => t.value),
      description: projectDescription,
      ...(currentBomId && { bill_of_materials_id: currentBomId }),
    };

    setProjectInfoLoading(true);
    try {
      const response = await fetch_backend("bill_materials/project_info/", "POST", token, dispatch, payload);
      // const response = { status: 200 }; // Mocked response
      if (response && response.status === 200) {
        setProjectInfoSaved(true);
        setBillOfMaterialsId(response.id || currentBomId);
        applyBomStatus(response, { read: false });
        setProjectInfoModal(false);
      }
    } catch (error) {
      console.error("Failed to save project info", error);
    } finally {
      setProjectInfoLoading(false);
    }
  };

  const openProductInfoModal = async () => {
    setProductInfoModal(true);
    setProductInfoLoading(true);
    try {
      const response = await fetch_backend("bill_materials/product_info/options/", "GET", token, dispatch);
      if (response && response.status === 200) {
        const sizeOpts = (response.sizes || []).map(s => ({ value: s.id, label: s.name }));
        const products = response.products || [];
        setSizeTagOptions(sizeOpts);
        setAllProducts(products);

        if (selectedSize) {
          const foundSize = sizeOpts.find(s => s.value === selectedSize.value);
          if (foundSize) setSelectedSize(foundSize);
        }
        if (selectedProduct) {
          const foundProduct = products.find(p => p.id === selectedProduct.value);
          if (foundProduct) {
            setSelectedProduct({
              value: foundProduct.id,
              label: foundProduct.name,
              description: foundProduct.description || "",
            });
          }
        }
      }
    } catch (error) {
      console.error("Failed to fetch product info options", error);
    } finally {
      setProductInfoLoading(false);
    }
  };

  const productOptions = useMemo(() => {
    if (!selectedSize) return [];
    return allProducts
      .filter(p => p.size_id === selectedSize.value)
      .map(p => ({ value: p.id, label: p.name, description: p.description || "" }));
  }, [selectedSize, allProducts]);

  const handleSizeChange = (option) => {
    setSelectedSize(option);
    setSelectedProduct(null);
    setProductDescription("");
  };

  const handleProductChange = (option) => {
    setSelectedProduct(option);
    setProductDescription(option ? option.description || "" : "");
  };

  const saveProductInfo = () => {
    if (!selectedSize || !selectedProduct) {
      setSuccessModalForm(false);
      setMessageModalForm("Los campos Tamaño y Producto son obligatorios.");
      setOpenModalForm(true);
      return;
    }
    setProductInfoSaved(true);
    setProductInfoModal(false);
  };

  const loadFromHistory = async (bomId) => {
    await loadBomDetail(bomId);
    setActiveTab('item-por-item');
  };

  const duplicateFromHistory = async (bomId, { isProduct = false } = {}) => {
    setIsLoading(true);
    try {
      const endpoint = isProduct ? `product_quote_price/${bomId}/` : `bill_materials/${bomId}/`;
      const response = await fetch_backend(endpoint, "GET", token, dispatch);
      if (response && response.status === 200) {
        const mapRows = (items, section) => (items || []).map(item => ({
          isNew: true,
          id: null,
          code: item.code ? { value: item.code, label: `${item.code}` } : { value: "", label: "" },
          description: item.description ? { value: item.id || item.description, label: item.description } : { value: "", label: "" },
          unit: item.unit || "",
          quantity: parseFloat(item.quantity) || 0,
          unitValue: parseFloat(item.unit_value) || 0,
          totalValue: parseFloat(item.total_value) || 0,
          recargo: section === 'labors' ? (parseFloat(item.recargo) || 1) : 1,
          updateDate: item.update_date || "",
          info: item.notes || item.info || "",
          attachments: [],
          code_material: item.code_material || null,
        }));
        const mapCostRows = (items) => (items || []).map(item => ({
          isNew: true,
          id: null,
          description: item.description ? { value: item.id || item.description, label: item.description } : { value: "", label: "" },
          unit: item.unit || "",
          quantity: 1,
          unitValue: parseFloat(item.unit_value) || 0,
          totalValue: parseFloat(item.total_value) || 0,
          info: item.notes || item.info || "",
          attachments: [],
          sum_from: item.sum_from || lookupSumFromInCatalog(item.description),
          percentage: parseFloat(item.percentage) || null,
        }));
        // Se muestran en el orden que envía el backend, sin reordenar.
        setMaterials(mapRows(response.materials, 'materials'));
        setLabors(mapRows(response.labors, 'labors'));
        setCosts(mapCostRows(response.costs));
        setContainers(mapRows(response.containers, 'containers'));

        if (response.percentages) {
          setAdminPercentage(response.percentages.admin ?? 10);
          setContingencyPercentage(response.percentages.contingency ?? 3);
          setUtilityPercentage(response.percentages.utility_adaptation ?? response.percentages.utility ?? 29);
          setContainerUtilityPercentage(response.percentages.utility_container ?? 15);
          setIvaPercentage(response.percentages.iva ?? 19);
        }
        if (response.trm_value) setTrmValue(response.trm_value);

        // No cargar info del proyecto/producto — se trata como nueva lista
        setBomColor(null);
        setBomStatusLabel(null);
        setInternalStatus("draft");
        setBillOfMaterialsId(null);
        setIsProductMode(false);
        setProjectInfoSaved(false);
        setProductInfoSaved(false);
        setSelectedClient(null);
        setSelectedQuote(null);
        setSelectedQuoteItems(null);
        setSelectedTags([]);
        setProjectName("");
        setProjectDescription("");
        setSelectedSize(null);
        setSelectedProduct(null);
        setProductDescription("");

        setActiveTab('item-por-item');
      }
    } catch (error) {
      console.error("Failed to duplicate BOM", error);
    } finally {
      setIsLoading(false);
    }
  };

  // Duplica la hoja de costos de un producto del catálogo como base de un
  // proyecto nuevo: trae líneas, porcentajes y TRM, y limpia toda la identidad
  // (no crea nada en backend).
  const duplicateFromProduct = (productId) => duplicateFromHistory(productId, { isProduct: true });

  const builDefaultSelectedOptions = (jsonResponse) => {
    setSelectedOptions({
      order_name: jsonResponse?.selected_options?.order_name || "",
    });
  };

  const addNewTableRow = (section) => {
    const setSectionState = getSectionSetter(section);
    let newState = { ...initialRowState };
    if (section === 'costs') {
      delete newState.code;
      delete newState.updateDate;
      newState.quantity = 1;
      newState.sum_from = null;
      newState.percentage = null;
    }
    // Se agrega la fila al final sin reordenar las existentes.
    setSectionState(prev => [...prev, newState]);
  };

  const removeTableRow = (index, section) => {
    const sectionState = getSectionState(section);
    const setSectionState = getSectionSetter(section);
    let tableRows_ = [...sectionState];
    tableRows_.splice(index, 1);
    setSectionState(tableRows_);
  };

  const changeOrderNameInput = (target) => {
    const options = { ...selectedOptions };
    options.order_name = target.value;
    setSelectedOptions(options);
  };

  const changeInputTable = (index_row, target, section) => {
    const sectionState = getSectionState(section);
    const setSectionState = getSectionSetter(section);

    let tableRows_ = [...sectionState];
    let value;
    const recargo = section === 'labors' ? (tableRows_[index_row]["recargo"] || 1) : 1;
    if (target.type === "number") {
      value = target.value === "" ? "" : (parseFloat(target.value) || 0);
      const numValue = value === "" ? 0 : value;
      if (target.name === "quantity") {
        tableRows_[index_row]["totalValue"] = numValue * (tableRows_[index_row]["unitValue"] || 0) * recargo;
      } else if (target.name === "recargo") {
        value = value === "" ? "" : Math.max(1, value);
        const recargoNum = value === "" ? 1 : value;
        tableRows_[index_row]["totalValue"] = (tableRows_[index_row]["quantity"] || 0) * (tableRows_[index_row]["unitValue"] || 0) * recargoNum;
      }
    } else if (target.name === "unitValue") {
      value = parseCurrency(target.value);
      tableRows_[index_row]["totalValue"] = value * (tableRows_[index_row]["quantity"] || 0) * recargo;
    } else {
      value = target.value;
    }
    tableRows_[index_row][target.name] = value;
    setSectionState(tableRows_);
  };

  const blurInputTable = (index_row, target, section) => {
    if (target.value === "") {
      const sectionState = getSectionState(section);
      const setSectionState = getSectionSetter(section);
      let tableRows_ = [...sectionState];
      const defaultValue = target.name === "recargo" ? 1 : 0;
      tableRows_[index_row][target.name] = defaultValue;
      setSectionState(tableRows_);
    }
  };

  const ChangeReactSelectTable = (selectOption, index, key, section) => {
    const sectionState = getSectionState(section);
    const setSectionState = getSectionSetter(section);
    const options = getSectionOptions(section);

    // En Materiales no se permite agregar un material que ya esté en la tabla.
    if (section === 'materials' && key === 'description' && selectOption) {
      const newLabel = (selectOption.label || "").toString().trim().toLowerCase();
      const isDuplicate = sectionState.some((row, i) => {
        if (i === index || !row.description) return false;
        if (selectOption.value != null && row.description.value === selectOption.value) return true;
        const existingLabel = (row.description.label || "").toString().trim().toLowerCase();
        return newLabel !== "" && existingLabel === newLabel;
      });
      if (isDuplicate) {
        setSuccessModalForm(false);
        setMessageModalForm("Este material ya fue agregado a la tabla.");
        setOpenModalForm(true);
        return;
      }
    }

    let tableRows_ = [...sectionState];
    let rowToChange = tableRows_[index];
    rowToChange[key] = selectOption;

    if (selectOption.__isNew__) {
      if (key === "description" && rowToChange["isNew"] === false) {
        rowToChange["code"] = { value: "-", label: "-", id: null };
      }
      rowToChange["isNew"] = true;
      rowToChange["id"] = null;
      rowToChange["unitValue"] = 0;
      if (section === 'costs') {
        rowToChange["quantity"] = 1;
        rowToChange["sum_from"] = null;
        rowToChange["percentage"] = null;
      }
    } else {
      rowToChange["isNew"] = false;
      // This part needs data from the options
      const reference = options.codes.find(
        (ref) => ref.id === selectOption.value
      ) || {};

      rowToChange["unit"] = reference?.unit;

      if (section === 'costs') {
        rowToChange["quantity"] = 1;
        if (reference?.unit === '%') {
          rowToChange["sum_from"] = reference?.sum_from || '';
          rowToChange["percentage"] = parseFloat(reference?.unit_value) || 0;
          const sectionSum = getSectionSumBySumFrom(reference?.sum_from);
          rowToChange["unitValue"] = sectionSum;
          rowToChange["totalValue"] = sectionSum * (parseFloat(reference?.unit_value) || 0) / 100;
        } else {
          rowToChange["sum_from"] = null;
          rowToChange["percentage"] = null;
          const uv = parseFloat(reference?.unit_value) || 0;
          rowToChange["unitValue"] = uv;
          rowToChange["totalValue"] = uv;
        }
      } else {
        const uv = parseFloat(reference?.unit_value) || 0;
        rowToChange["unitValue"] = uv;
        const recargo = section === 'labors' ? (rowToChange["recargo"] || 1) : 1;
        rowToChange["totalValue"] = uv * (parseFloat(rowToChange["quantity"]) || 0) * recargo;
      }

      if (key == "code") {
        rowToChange["description"] = {
          id: reference.id,
          value: reference.code,
          label: reference.description,
        };
        rowToChange["id"] = reference.id;
      } else {
        rowToChange["code"] = { value: reference.code, label: reference.code, id: reference.id };
        rowToChange["id"] = reference.id;
      }

      // Asignar code_material si existe en la referencia
      if (reference.code_material) {
        rowToChange["code_material"] = reference.code_material;
      }
    }

    setSectionState(tableRows_);
  };

  const buildOptions = (items) => {
    if (!items) return { codes: [], descriptions: [] };

    const codes = items.map(item => ({
      ...item,
      code: item.id, // Assuming id can be used as code for now
      unit_value: parseFloat(item.price) || 0,
    }));

    const descriptions = items.map(item => ({
      value: item.id,
      label: item.description,
    }));

    return { codes, descriptions };
  };

  const buildAlwaysVisibleCostRows = (items) => {
    return (items || [])
      .filter(item => item.always_visible === true)
      .map(item => {
        const price = parseFloat(item.price) || 0;
        const isPercentage = item.unit === '%' && !!item.sum_from;
        return {
          isNew: true,
          id: null,
          description: { value: item.id, label: item.description },
          unit: item.unit || "",
          quantity: 1,
          unitValue: isPercentage ? 0 : price,
          totalValue: isPercentage ? 0 : price,
          info: "",
          attachments: [],
          sum_from: item.sum_from || lookupSumFromInCatalog(item.description),
          percentage: isPercentage ? price : null,
        };
      });
  };

  const getDataFromTable = (tableState, isCosts = false, isLabors = false) => {
    return tableState.map(row => {
      // Para costos, base y total se derivan de las sumas actuales (fuente de
      // verdad), no de los valores almacenados en la fila.
      const values = isCosts
        ? computeCostRowValues(row)
        : { unitValue: row.unitValue, totalValue: row.totalValue };
      const base = {
        id: row.id,
        code: row.code ? row.code.value : undefined,
        quantity: row.quantity,
        description: row.description?.label,
        unit: row.unit,
        unit_value: values.unitValue,
        total_value: values.totalValue,
        update_date: row.updateDate,
        info: row.info,
        is_new: row.isNew
      };
      if (isCosts) {
        base.sum_from = row.sum_from || null;
        base.percentage = row.percentage || null;
      }
      if (isLabors) {
        base.recargo = row.recargo || 1;
      }
      return base;
    });
  };

  const validateRequiredFields = (allValues) => {
    const errors = {};
    const validateItems = (items, sectionName) => {
        const itemErrors = [];
        items.forEach((item, index) => {
            if (!item.description || item.description.trim() === "") {
                itemErrors.push(`Falta 'Descripción' en ${sectionName}, fila ${index + 1}`);
            }
            if (!item.quantity || item.quantity === 0) {
                itemErrors.push(`Falta 'Cantidad' en ${sectionName}, fila ${index + 1}`);
            }
        });
        return itemErrors;
    };
    
    const materialsErrors = validateItems(allValues.materials, 'Materiales');
    const laborsErrors = validateItems(allValues.labors, 'Mano de Obra');
    const costsErrors = validateItems(allValues.costs, 'Costos');
    const containersErrors = validateItems(allValues.containers, 'Contenedores');

    const allErrors = [...materialsErrors, ...laborsErrors, ...costsErrors, ...containersErrors];

    if (allErrors.length > 0) {
        errors.items = allErrors;
    }

    return errors;
};


  const send_request = async (method, allValues, isDraft = false) => {
    setIsLoading(true);
    let url;
    let requestMethod = method;
    if (isProductMode) {
      const productId = selectedProduct?.value || bom_id;
      url = `product_quote_price/${productId}/`;
      requestMethod = "POST";
    } else {
      const baseEndpointUrl = "bill_materials/";
      const existingId = billOfMaterialsId || bom_id;
      if (is_new && !existingId) {
        url = baseEndpointUrl;
      } else {
        url = `${baseEndpointUrl}${existingId}/`;
        requestMethod = "PUT";
      }
    }

    const response = await fetch_backend(
      url,
      requestMethod,
      token,
      dispatch,
      allValues
    );
    setIsLoading(false);

    if (response.status === 200) {
      if (!isProductMode && response.order?.id) {
        setBillOfMaterialsId(response.order.id);
      }
      // "Guardar definitivo" no siempre deja la hoja en saved: si la cotización
      // ya salió de borrador queda in_process o confirmed. Se repinta con lo
      // que devuelve el backend, no con lo que se mandó.
      applyBomStatus(response, { read: false });
      setSuccessfulOrderCreation(!isDraft);
      setSuccessModalForm(true);
      setMessageModalForm(
        isProductMode
          ? ["Operación Exitosa"]
          : ["Operación Exitosa", `Nro de Hoja Costos: ${response.order?.id}`]
      );
      setOpenModalForm(true);
    }
  };

  const onCloseModalForm = () => {
    if (successfulOrderCreation) {
      history.push(isProductMode ? url_bom_products : url_bill_of_materials);
    } else {
      setOpenModalForm(false);
    }
  };

  const saveOrder = (saveStatus) => {
    const isDraft = saveStatus === "draft";

    // Para hojas nuevas se exige la información del proyecto/producto incluso para guardar en borrador.
    if (!isProductMode && !projectInfoSaved && (!isDraft || is_new)) {
      setSuccessModalForm(false);
      setMessageModalForm("Debe diligenciar la Información del Proyecto antes de guardar.");
      setOpenModalForm(true);
      return;
    }
    if (isProductMode && !productInfoSaved && (!isDraft || is_new)) {
      setSuccessModalForm(false);
      setMessageModalForm("Debe diligenciar la Información del Producto antes de guardar.");
      setOpenModalForm(true);
      return;
    }

    const totalsData = calculateTotals();

    const allValues = {
      // Solo la elección del usuario. in_process / confirmed / eliminated /
      // finished los calcula el backend a partir de la cotización.
      status: isDraft ? "draft" : "saved",
      bill_of_materials_id: billOfMaterialsId,
      order_name: selectedOptions?.order_name,
      date: currentDate,
      ...(isProductMode && {
        product_info: {
          size_id: selectedSize?.value || null,
          product_id: selectedProduct?.value || null,
          description: productDescription,
        },
      }),
      percentages: {
        utility_adaptation: utilityPercentage,
        utility_container: containerUtilityPercentage,
        admin: adminPercentage,
        contingency: contingencyPercentage,
        iva: ivaPercentage
      },
      materials: getDataFromTable(materials),
      labors: getDataFromTable(labors, false, true),
      costs: getDataFromTable(costs, true),
      containers: getDataFromTable(containers),
      totals: {
        subtotal: totalsData.subtotal,
        subtotal_materials: totalsData.subtotalMaterials,
        subtotal_labors: totalsData.subtotalLabors,
        subtotal_costs: totalsData.subtotalCosts,
        subtotal_containers_usd: totalsData.subtotalContainersUsd,
        subtotal_containers: totalsData.subtotalContainers,
        admin_percentage: adminPercentage,
        admin_value: totalsData.adminValue,
        contingency_percentage: contingencyPercentage,
        contingency_value: totalsData.contingencyValue,
        utility_adaptation_percentage: utilityPercentage,
        utility_adaptation_value: totalsData.utilityAdaptationValue,
        utility_container_percentage: containerUtilityPercentage,
        utility_container_value: totalsData.utilityContainerValue,
        total_aiu: totalsData.totalAIU,
        trm_value: trmValue || 0,
        iva_percentage: ivaPercentage,
        iva_value: totalsData.ivaValue,
        total: totalsData.total,
        grand_total: totalsData.grandTotal
      }
    };

    const allItems = [...allValues.materials, ...allValues.labors, ...allValues.costs, ...allValues.containers];

    if (allItems.length === 0) {
      setSuccessModalForm(false);
      setMessageModalForm("No hay items para guardar");
      setOpenModalForm(true);
      return;
    }
    const errors = validateRequiredFields(allValues);
    const method = is_new ? "POST" : "PUT";

    if (!_.isEmpty(errors)) {
      setSuccessModalForm(false);
      setMessageModalForm(errors);
      setOpenModalForm(true);
      return;
    }
    console.log(allValues);
    send_request(method, allValues, isDraft);
  };

  const calculateTotals = () => {
    const subtotalMaterials = materials.reduce((acc, row) => acc + (row.totalValue || 0), 0);
    const subtotalLabors = labors.reduce((acc, row) => acc + (row.totalValue || 0), 0);
    const subtotalCosts = costs.reduce((acc, row) => acc + (computeCostRowValues(row).totalValue || 0), 0);
    const subtotalContainersUsd = getSubtotalContainers();
    const subtotalContainers = subtotalContainersUsd * (trmValue || 0);
    const subtotalAdaptation = subtotalMaterials + subtotalLabors + subtotalCosts;
    const subtotal = subtotalAdaptation + subtotalContainers;

    // AIU sobre adaptacion (materiales + mano de obra + costos)
    const adminValue = (subtotalAdaptation * adminPercentage) / 100;
    const contingencyValue = (subtotalAdaptation * contingencyPercentage) / 100;

    // Utilidad: (sumaCostos / (1 - utilidad)) - sumaCostos
    const utilityAdaptationDecimal = utilityPercentage / 100;
    const utilityAdaptationValue = utilityAdaptationDecimal < 1
      ? (subtotalAdaptation / (1 - utilityAdaptationDecimal)) - subtotalAdaptation
      : 0;

    const containerUtilityDecimal = containerUtilityPercentage / 100;
    const utilityContainerValue = containerUtilityDecimal < 1
      ? (subtotalContainers / (1 - containerUtilityDecimal)) - subtotalContainers
      : 0;

    const totalAIU = adminValue + contingencyValue + utilityAdaptationValue + utilityContainerValue;

    // Total antes de IVA
    const total = subtotal + totalAIU;

    // IVA
    const ivaValue = (total * ivaPercentage) / 100;

    // Total final
    const grandTotal = total + ivaValue;

    return {
      subtotal,
      subtotalMaterials,
      subtotalLabors,
      subtotalCosts,
      subtotalContainersUsd,
      subtotalContainers,
      subtotalAdaptation,
      utilityAdaptationValue,
      utilityContainerValue,
      adminValue,
      contingencyValue,
      totalAIU,
      total,
      ivaValue,
      grandTotal
    };
  };

  const handlePercentageChange = (value, setter) => {
    const numericValue = value === '' ? 0 : parseFloat(value);
    setter(numericValue);
  };

  const renderTableSection = (title, section, rows, setRows) => {
    const isCostSection = section === 'costs';
    const isContainerSection = section === 'containers';
    const isLaborSection = section === 'labors';
    const showDragHandle = section === 'materials' && canReorderMaterials;
    const options = getSectionOptions(section);
    const sectionSubtotal = rows.reduce((acc, row) => acc + (
      isCostSection ? computeCostRowValues(row).totalValue : (row.totalValue || 0)
    ), 0);
    const sectionTotalHours = isLaborSection
      ? rows.reduce((acc, row) => acc + (row.quantity || 0), 0)
      : null;
    const hasRows = rows.length > 0;

    return (
      <>
        <SectionDivider
          title={title}
          count={rows.length}
          subtotal={sectionSubtotal}
          formatCurrency={formatCurrency}
          totalHours={sectionTotalHours}
        />
        <div style={{ width: "100%" }}>
          {hasRows ? (
            <table className="bom-table">
              <thead>
                <tr>
                  {showDragHandle && <th style={{ width: "4%" }}></th>}
                  <th style={{ width: "5%" }}>No.</th>
                  <th style={{ width: isLaborSection ? "35%" : "40%" }}>Descripción</th>
                  <th style={{ width: "10%" }}>Unidad</th>
                  <th style={{ width: "10%" }}>Cantidad</th>
                  {isLaborSection && <th style={{ width: "8%" }}>Recargo</th>}
                  <th style={{ width: "10%" }}>{isContainerSection ? "Valor Unit. (USD)" : "Valor Unit."}</th>
                  <th style={{ width: "10%" }}>{isContainerSection ? "Valor Total (USD)" : "Valor Total"}</th>
                  {!isReadOnly && <th style={{ width: "5%", textAlign: "center" }}>Info</th>}
                  {!isReadOnly && <th style={{ width: "5%", textAlign: "center" }}>Eliminar</th>}
                </tr>
              </thead>
              <tbody>
                {rows.map((row, index) => {
                  const isCostPercentage = isCostSection && row.unit === '%';
                  // Base y total mostrados: derivados en vivo para filas de costo.
                  const displayValues = isCostSection
                    ? computeCostRowValues(row)
                    : { unitValue: row.unitValue, totalValue: row.totalValue };
                  return (
                  <tr
                    key={index}
                    draggable={showDragHandle && materialDragEnabled}
                    onDragStart={showDragHandle ? () => handleMaterialDragStart(index) : undefined}
                    onDragOver={showDragHandle ? (e) => handleMaterialDragOver(e, index) : undefined}
                    onDrop={showDragHandle ? () => handleMaterialDrop(index) : undefined}
                    onDragEnd={showDragHandle ? handleMaterialDragEnd : undefined}
                    className={showDragHandle && materialDragOverIndex === index && materialDragIndex !== index ? "bom-row-drag-over" : ""}
                    onKeyDown={(e) => {
                      if (e.key === 'Enter' && !e.shiftKey && !isReadOnly) {
                        e.preventDefault();
                        addNewTableRow(section);
                      }
                    }}>
                    {showDragHandle && (
                      <td
                        className="bom-drag-handle"
                        title="Arrastra para reordenar"
                        style={{ textAlign: "center", cursor: "grab" }}
                        onMouseDown={() => setMaterialDragEnabled(true)}
                        onMouseUp={() => setMaterialDragEnabled(false)}
                      >
                        <FontAwesomeIcon icon={faGripVertical} color="#999" />
                      </td>
                    )}
                    <td>{index + 1}</td>
                    <td>
                      {isReadOnly ? (
                        <span className="readonly-cell">{row.description?.label || "-"}</span>
                      ) : (
                        <CreatableSelect
                          className="basic-single"
                          classNamePrefix="select"
                          placeholder="Seleccione..."
                          isSearchable={true}
                          options={options.descriptions}
                          styles={styles_react_select}
                          onChange={(value) => ChangeReactSelectTable(value, index, "description", section)}
                          value={row.description?.value ? row.description : null}
                          filterOption={(option, inputValue) => {
                            if (!inputValue) return true;
                            const label = (option.label || "").toLowerCase();
                            const words = inputValue.toLowerCase().split(/\s+/).filter(Boolean);
                            return words.every(word => label.includes(word));
                          }}
                        />
                      )}
                    </td>
                    <td>
                      <input
                        type="text"
                        name="unit"
                        className="my_input input_center"
                        value={row.unit}
                        onChange={(event) => changeInputTable(index, event.target, section)}
                        disabled={isReadOnly || !row.isNew}
                        style={{ color: 'black' }}
                      />
                    </td>
                    <td>
                      {isCostPercentage ? (
                        <div className="cost-percentage-cell">
                          <input
                            type="number"
                            name="percentage"
                            className="my_input input_center"
                            value={row.percentage || 0}
                            onChange={(e) => handleCostPercentageChange(index, parseFloat(e.target.value) || 0)}
                            disabled={isReadOnly}
                            style={isReadOnly ? { color: 'black' } : {}}
                          />
                          <span className="cost-percentage-symbol">%</span>
                        </div>
                      ) : (
                        <input
                          type="number"
                          name="quantity"
                          className="my_input input_center"
                          value={row.quantity}
                          onChange={(event) => changeInputTable(index, event.target, section)}
                          onBlur={(event) => blurInputTable(index, event.target, section)}
                          disabled={isReadOnly || isCostSection}
                          style={(isReadOnly || isCostSection) ? { color: 'black' } : {}}
                        />
                      )}
                    </td>
                    {isLaborSection && (
                      <td>
                        <input
                          type="number"
                          name="recargo"
                          className="my_input input_center"
                          value={row.recargo}
                          min={1}
                          step={0.1}
                          onChange={(event) => changeInputTable(index, event.target, section)}
                          onBlur={(event) => blurInputTable(index, event.target, section)}
                          disabled={isReadOnly}
                          style={isReadOnly ? { color: 'black' } : {}}
                        />
                      </td>
                    )}
                    <td>
                      <input
                        type="text"
                        name="unitValue"
                        className="my_input input_center"
                        value={isCostPercentage
                          ? formatCurrency(displayValues.unitValue)
                          : (editingUnitValue === `${section}-${index}` ?
                            row.unitValue.toString() :
                            formatCurrency(row.unitValue))}
                        onChange={(isCostPercentage || isReadOnly) ? undefined : (event) => handleUnitValueChange(index, event.target.value, section)}
                        onFocus={(isCostPercentage || isReadOnly) ? undefined : () => handleUnitValueFocus(`${section}-${index}`)}
                        onBlur={(isCostPercentage || isReadOnly) ? undefined : () => handleUnitValueBlur()}
                        disabled={isCostPercentage || isReadOnly}
                        style={(isCostPercentage || isReadOnly) ? { color: 'black' } : {}}
                      />
                      {isCostPercentage && row.sum_from && (
                        <span className="cost-sum-from-label">
                          Base: {row.sum_from === 'materiales' ? 'Materiales' : row.sum_from === 'mano_obra' ? 'Mano de Obra' : row.sum_from === 'contenedores' ? 'Contenedores' : 'Total'}
                        </span>
                      )}
                    </td>
                    <td>
                      <input
                        type="text"
                        name="totalValue"
                        className="my_input input_center"
                        value={formatCurrency(displayValues.totalValue)}
                        disabled={true}
                        style={{ color: 'black' }}
                      />
                    </td>
                    {!isReadOnly && (
                      <td style={{ textAlign: "center" }}>
                        <FontAwesomeIcon
                          icon={faInfoCircle}
                          size="lg"
                          color={(row.info || row.attachments?.length) ? "#006B3C" : "#ccc"}
                          style={{ cursor: "pointer" }}
                          onClick={() => openInfoModal(section, index)}
                        />
                      </td>
                    )}
                    {!isReadOnly && (
                      <td
                        style={{ textAlign: "center", cursor: "pointer" }}
                        onClick={() => removeTableRow(index, section)}
                      >
                        <FontAwesomeIcon icon={faTrash} size="lg" color="red" />
                      </td>
                    )}
                  </tr>
                  );
                })}
              </tbody>
            </table>
          ) : (
            <div className="empty-section">
              <div className="empty-section-icon">
                <FontAwesomeIcon icon={faInfoCircle} />
              </div>
              <div>No hay elementos en esta sección.</div>
            </div>
          )}
          {!isReadOnly && (
            <div className="add-row-container">
              <div className="simple_square_plus" onClick={() => addNewTableRow(section)}>
                +
              </div>
            </div>
          )}
        </div>
      </>
    );
  };

  return (
    <>
      <ModalForm
        open={openModalForm}
        onClose={() => onCloseModalForm()}
        successModal={successModalForm}
        messageModal={messageModalForm}
      />

      {/* Project Info Modal */}
      <Dialog
        open={projectInfoModal}
        onClose={() => setProjectInfoModal(false)}
        maxWidth="sm"
        fullWidth
        PaperProps={{ style: { overflow: "visible" } }}
      >
        <DialogTitle>
          <div className="project-info-modal-title">
            <span>Información del Proyecto</span>
            <button className="modal-close-btn" onClick={() => setProjectInfoModal(false)}>
              <FontAwesomeIcon icon={faTimes} />
            </button>
          </div>
        </DialogTitle>
        <DialogContent style={{ overflow: "visible" }}>
          {projectInfoLoading ? (
            <div style={{ textAlign: "center", padding: "40px" }}>Cargando...</div>
          ) : (
            <div className="project-info-form">
              <div className="project-info-field">
                <label className="project-info-label">Nombre</label>
                <input
                  type="text"
                  className="project-info-input"
                  placeholder="Nombre del proyecto..."
                  value={projectName}
                  onChange={(e) => setProjectName(e.target.value)}
                />
              </div>

              <div className="project-info-field">
                <label className="project-info-label">Cliente *</label>
                <Select
                  placeholder="Seleccione un cliente..."
                  options={clientOptions}
                  styles={styles_react_select}
                  value={selectedClient}
                  onChange={handleClientChange}
                  isClearable
                />
              </div>

              <div className="project-info-field">
                <label className="project-info-label">Cotización</label>
                <Select
                  placeholder={selectedClient ? "Seleccione una cotización..." : "Seleccione un cliente primero"}
                  options={filteredQuotes}
                  styles={styles_react_select}
                  value={selectedQuote}
                  onChange={handleQuoteChange}
                  isClearable
                  isDisabled={!selectedClient}
                />
              </div>

              <div className="project-info-field">
                <label className="project-info-label">Ítem de Cotización</label>
                <Select
                  placeholder={selectedQuote ? "Seleccione un ítem..." : "Seleccione una cotización primero"}
                  options={quoteItemOptions}
                  styles={styles_react_select}
                  value={selectedQuoteItems}
                  onChange={(option) => setSelectedQuoteItems(option || null)}
                  isClearable
                  isDisabled={!selectedQuote}
                />
              </div>

              <div className="project-info-field">
                <label className="project-info-label">Tags *</label>
                <Select
                  placeholder="Seleccione tags..."
                  options={tagOptions}
                  styles={styles_multi_select}
                  value={selectedTags}
                  onChange={(options) => setSelectedTags(options || [])}
                  isMulti
                  closeMenuOnSelect={false}
                />
              </div>

              <div className="project-info-field">
                <label className="project-info-label">Descripción</label>
                <textarea
                  className="project-info-textarea"
                  placeholder="Descripción del proyecto..."
                  value={projectDescription}
                  onChange={(e) => setProjectDescription(e.target.value)}
                  rows={4}
                />
              </div>

              <button className="btn-project-info-save" onClick={saveProjectInfo} disabled={projectInfoLoading} style={{ marginTop: "10px" }}>
                <FontAwesomeIcon icon={faSave} />
                <span>Guardar Información</span>
              </button>
            </div>
          )}
        </DialogContent>
      </Dialog>

      {/* Product Info Modal */}
      <Dialog
        open={productInfoModal}
        onClose={() => setProductInfoModal(false)}
        maxWidth="sm"
        fullWidth
        PaperProps={{ style: { overflow: "visible" } }}
      >
        <DialogTitle>
          <div className="project-info-modal-title">
            <span>Información del Producto</span>
            <button className="modal-close-btn" onClick={() => setProductInfoModal(false)}>
              <FontAwesomeIcon icon={faTimes} />
            </button>
          </div>
        </DialogTitle>
        <DialogContent style={{ overflow: "visible" }}>
          {productInfoLoading ? (
            <div style={{ textAlign: "center", padding: "40px" }}>Cargando...</div>
          ) : (
            <div className="project-info-form">
              <div className="project-info-field">
                <label className="project-info-label">Tamaño *</label>
                <Select
                  placeholder="Seleccione un tamaño..."
                  options={sizeTagOptions}
                  styles={styles_react_select}
                  value={selectedSize}
                  onChange={handleSizeChange}
                  isClearable
                />
              </div>

              <div className="project-info-field">
                <label className="project-info-label">Producto *</label>
                <Select
                  placeholder={selectedSize ? "Seleccione un producto..." : "Primero seleccione un tamaño"}
                  options={productOptions}
                  styles={styles_react_select}
                  value={selectedProduct}
                  onChange={handleProductChange}
                  isClearable
                  isDisabled={!selectedSize}
                />
              </div>

              <div className="project-info-field">
                <label className="project-info-label">Descripción</label>
                <textarea
                  className="project-info-textarea"
                  placeholder="Descripción del producto..."
                  value={productDescription}
                  onChange={(e) => setProductDescription(e.target.value)}
                  rows={6}
                />
              </div>

              <button className="btn-project-info-save" onClick={saveProductInfo} disabled={productInfoLoading} style={{ marginTop: "10px" }}>
                <FontAwesomeIcon icon={faSave} />
                <span>Guardar Información</span>
              </button>
            </div>
          )}
        </DialogContent>
      </Dialog>

      {/* Item Info Modal */}
      <Dialog
        open={infoModal.open}
        onClose={closeInfoModal}
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle>
          <div className="project-info-modal-title">
            <span>Información del Ítem</span>
            <button className="modal-close-btn" onClick={closeInfoModal}>
              <FontAwesomeIcon icon={faTimes} />
            </button>
          </div>
        </DialogTitle>
        <DialogContent>
          <div className="info-modal-content">
            <label className="info-modal-label">Notas</label>
            {infoNotesEditing ? (
              <textarea
                ref={infoNotesTextareaRef}
                className="info-modal-textarea"
                value={infoNotes}
                onChange={(e) => setInfoNotes(e.target.value)}
                onBlur={() => setInfoNotesEditing(false)}
                placeholder="Escribe notas, pega URLs..."
                rows={6}
                autoFocus
              />
            ) : (
              <div
                className="info-modal-textarea info-modal-textarea-display"
                onClick={() => setInfoNotesEditing(true)}
              >
                {infoNotes ? linkifyText(infoNotes) : <span className="info-modal-placeholder">Escribe notas, pega URLs...</span>}
              </div>
            )}

            <label className="info-modal-label" style={{ marginTop: '16px' }}>Imágenes</label>

            {infoExistingAttachments.length > 0 && (
              <div className="info-attachments-grid">
                {infoExistingAttachments.map((att, i) => (
                  <div key={att.id || i} className="info-attachment-item">
                    <img src={att.url} alt={att.filename} />
                    <button className="info-attachment-remove" onClick={() => removeExistingAttachment(i)}>
                      <FontAwesomeIcon icon={faTimes} />
                    </button>
                    <span className="info-attachment-name">{att.filename}</span>
                  </div>
                ))}
              </div>
            )}

            {infoNewFiles.length > 0 && (
              <div className="info-attachments-grid">
                {infoNewFiles.map((file, i) => (
                  <div key={i} className="info-attachment-item">
                    <img src={URL.createObjectURL(file)} alt={file.name} />
                    <button className="info-attachment-remove" onClick={() => removeNewFile(i)}>
                      <FontAwesomeIcon icon={faTimes} />
                    </button>
                    <span className="info-attachment-name">{file.name}</span>
                  </div>
                ))}
              </div>
            )}

            <div
              className={`info-dropzone ${infoDragActive ? 'info-dropzone-active' : ''}`}
              onDragEnter={handleInfoDragOver}
              onDragOver={handleInfoDragOver}
              onDragLeave={handleInfoDragLeave}
              onDrop={handleInfoDrop}
              onClick={() => infoFileInputRef.current?.click()}
            >
              <FontAwesomeIcon icon={faUpload} size="lg" color="#999" />
              <p>Arrastra imágenes aquí o haz clic para seleccionar</p>
              <input
                ref={infoFileInputRef}
                type="file"
                accept="image/*"
                multiple
                onChange={handleInfoFileInput}
                style={{ display: 'none' }}
              />
            </div>
          </div>
        </DialogContent>
        <DialogActions>
          <button className="btn-project-info-save" onClick={saveItemInfo} disabled={infoSaving}>
            <FontAwesomeIcon icon={faSave} />
            <span>{infoSaving ? "Guardando..." : "Guardar"}</span>
          </button>
        </DialogActions>
      </Dialog>

      <div className="main_container_orders_detail">
        <Loading isLoading={isLoading} />

        {!isReadOnly && !isProductMode && !projectInfoSaved && (
          <div className="project-info-alert" onClick={openProjectInfoModal}>
            <FontAwesomeIcon icon={faExclamationTriangle} className="alert-icon" />
            <span>La información del proyecto no ha sido diligenciada. Haz clic aquí para completarla.</span>
          </div>
        )}
        {!isReadOnly && isProductMode && !productInfoSaved && (
          <div className="project-info-alert" onClick={openProductInfoModal}>
            <FontAwesomeIcon icon={faExclamationTriangle} className="alert-icon" />
            <span>La información del producto no ha sido diligenciada. Haz clic aquí para completarla.</span>
          </div>
        )}
        
        <div className="bom-top-header">
          <button className="btn-back" onClick={() => history.push(isProductMode ? url_bom_products : url_bill_of_materials)}>
            <FontAwesomeIcon icon={faArrowLeft} />
            <span>Volver</span>
          </button>
          
          <div className="bom-header-center">
            <h1 className="bom-main-title">{isReadOnly ? `Hoja de Costos #${bom_id}` : is_new ? "Nueva Hoja de Costos" : `Detalle Hoja de Costos ${(billOfMaterialsId || bom_id) ? `#${billOfMaterialsId || bom_id}` : ""}`}</h1>
            {/* Badge del estado. Se pinta con lo que manda el backend y se
                repinta solo tras guardar. No se muestra en hojas nuevas ni en
                modo producto porque ahí todavía no hay estado. */}
            <StatusBadge
              color={bomColor}
              label={bomStatusLabel}
              className="bom-main-status"
            />
            {(isReadOnly || is_new || projectDescription) && (
              <p className="bom-main-subtitle">{isReadOnly ? "Vista de solo lectura" : is_new ? "Crear Hoja de Costos para contenedor marítimo" : projectDescription}</p>
            )}
          </div>
          
          {!isReadOnly && !isProductMode && (
            <div className="bom-header-actions">
              <button
                className={`btn-header-action ${!projectInfoSaved ? 'btn-header-action--alert' : 'btn-header-action--ok'}`}
                onClick={openProjectInfoModal}
              >
                <FontAwesomeIcon icon={faCog} />
                <span>Información del Proyecto</span>
              </button>
            </div>
          )}
          {!isReadOnly && isProductMode && (
            <div className="bom-header-actions">
              <button
                className={`btn-header-action ${!productInfoSaved ? 'btn-header-action--alert' : 'btn-header-action--ok'}`}
                onClick={openProductInfoModal}
              >
                <FontAwesomeIcon icon={faCog} />
                <span>Información del Producto</span>
              </button>
            </div>
          )}
        </div>

        {!isReadOnly && (
          <div className="bom-tabs-container">
            <div className="bom-tabs">
              <button
                className={`bom-tab ${activeTab === 'item-por-item' ? 'active' : ''}`}
                onClick={() => setActiveTab('item-por-item')}
              >
                <FontAwesomeIcon icon={faList} />
                <span>Ítem por ítem</span>
              </button>
              <button
                className={`bom-tab ${activeTab === 'apus' ? 'active' : ''}`}
                onClick={() => setActiveTab('apus')}
              >
                <FontAwesomeIcon icon={faMoneyBillWave} />
                <span>APUs</span>
              </button>
              <button
                className={`bom-tab ${activeTab === 'historico' ? 'active' : ''}`}
                onClick={() => { setActiveTab('historico'); }}
              >
                <FontAwesomeIcon icon={faHistory} />
                <span>Histórico</span>
              </button>
              {/* Solo al armar una hoja de costos de proyecto: en modo producto
                  no tiene sentido duplicar otro producto sobre sí mismo. */}
              {!isProductMode && (
                <button
                  className={`bom-tab ${activeTab === 'productos' ? 'active' : ''}`}
                  onClick={() => { setActiveTab('productos'); }}
                >
                  <FontAwesomeIcon icon={faBox} />
                  <span>Productos</span>
                </button>
              )}
            </div>
          </div>
        )}
        
        {(activeTab === 'item-por-item' || isReadOnly) && (
          <div className="bom-main-layout">
            <div className="bom-left-section">
              {renderTableSection("Materiales", "materials", materials, setMaterials)}
              {renderTableSection("Mano de Obra", "labors", labors, setLabors)}
              {renderTableSection("Costos Indirectos", "costs", costs, setCosts)}
              {renderTableSection("Contenedores", "containers", containers, setContainers)}
            </div>

            <div className="bom-right-section">
            <div className="totals-container">
              <div className="totals-header">
                <FontAwesomeIcon icon={faCalculator} className="totals-header-icon" size="lg" />
                <h4 className="totals-header-title">Resumen y Totales</h4>
              </div>

              <div className="totals-content">
                {/* Subtotal con desglose */}
                <div className="totals-row">
                  <span className="totals-label-bold">Costo</span>
                  <span className="totals-value">{formatCurrency(calculateTotals().subtotal)}</span>
                </div>
                <div className="totals-row-sub">
                  <span className="totals-label-sub">Materiales</span>
                  <span className="totals-value-sub">{formatCurrency(calculateTotals().subtotalMaterials)}</span>
                </div>
                <div className="totals-row-sub">
                  <span className="totals-label-sub">Mano de Obra</span>
                  <span className="totals-value-sub">{formatCurrency(calculateTotals().subtotalLabors)}</span>
                </div>
                <div className="totals-row-sub">
                  <span className="totals-label-sub">Costos Indirectos</span>
                  <span className="totals-value-sub">{formatCurrency(calculateTotals().subtotalCosts)}</span>
                </div>
                <div className="totals-row-sub">
                  <span className="totals-label-sub">Contenedores (USD {calculateTotals().subtotalContainersUsd.toLocaleString('en-US', { minimumFractionDigits: 0 })} x {trmValue})</span>
                  <span className="totals-value-sub">{formatCurrency(calculateTotals().subtotalContainers)}</span>
                </div>

                {/* AIU Section */}
                <div className="totals-section-title">AIU</div>

                <div className="totals-row-percentage">
                  <span className="totals-label">Administracion</span>
                  <div className="percentage-value-group">
                    <div className="percentage-group">
                      <input
                        type="number"
                        className="percentage-small-input"
                        value={adminPercentage}
                        onChange={(e) => handlePercentageChange(e.target.value, setAdminPercentage)}
                        disabled={isReadOnly || (!is_edit && !is_new)}
                      />
                      <span className="percentage-symbol">%</span>
                    </div>
                    <span className="percentage-currency-value">{formatCurrency(calculateTotals().adminValue)}</span>
                  </div>
                </div>

                <div className="totals-row-percentage">
                  <span className="totals-label">Imprevistos</span>
                  <div className="percentage-value-group">
                    <div className="percentage-group">
                      <input
                        type="number"
                        className="percentage-small-input"
                        value={contingencyPercentage}
                        onChange={(e) => handlePercentageChange(e.target.value, setContingencyPercentage)}
                        disabled={isReadOnly || (!is_edit && !is_new)}
                      />
                      <span className="percentage-symbol">%</span>
                    </div>
                    <span className="percentage-currency-value">{formatCurrency(calculateTotals().contingencyValue)}</span>
                  </div>
                </div>

                <div className="totals-row-percentage">
                  <span className="totals-label">Utilidad Adaptacion</span>
                  <div className="percentage-value-group">
                    <div className="percentage-group">
                      <input
                        type="number"
                        className="percentage-small-input"
                        value={utilityPercentage}
                        onChange={(e) => handlePercentageChange(e.target.value, setUtilityPercentage)}
                        disabled={isReadOnly || (!is_edit && !is_new)}
                      />
                      <span className="percentage-symbol">%</span>
                    </div>
                    <span className="percentage-currency-value">{formatCurrency(calculateTotals().utilityAdaptationValue)}</span>
                  </div>
                </div>

                <div className="totals-row-percentage">
                  <span className="totals-label">Utilidad Contenedor</span>
                  <div className="percentage-value-group">
                    <div className="percentage-group">
                      <input
                        type="number"
                        className="percentage-small-input"
                        value={containerUtilityPercentage}
                        onChange={(e) => handlePercentageChange(e.target.value, setContainerUtilityPercentage)}
                        disabled={isReadOnly || (!is_edit && !is_new)}
                      />
                      <span className="percentage-symbol">%</span>
                    </div>
                    <span className="percentage-currency-value">{formatCurrency(calculateTotals().utilityContainerValue)}</span>
                  </div>
                </div>

                <div className="totals-row">
                  <span className="totals-label-bold">Total AIU:</span>
                  <span className="totals-value">{formatCurrency(calculateTotals().totalAIU)}</span>
                </div>

                {/* TRM Section */}
                <div className="totals-row-trm">
                  <span className="totals-label">TRM (COP/USD) + 50 pesos</span>
                </div>
                <div className="trm-input-group">
                  <input
                    type="number"
                    className="trm-input"
                    value={trmValue}
                    onChange={(e) => setTrmValue(e.target.value === "" ? "" : (parseFloat(e.target.value) || 0))}
                    onBlur={(e) => { if (e.target.value === "") setTrmValue(0); }}
                    disabled={isReadOnly || (!is_edit && !is_new)}
                  />
                  <button className="trm-refresh-btn" onClick={fetchTrm} disabled={trmLoading}>
                    <FontAwesomeIcon icon={faSync} spin={trmLoading} />
                  </button>
                </div>

                {/* Subtotal antes de IVA */}
                <div className="totals-row-total">
                  <span className="totals-label-bold">Subtotal</span>
                  <span className="totals-value-green">{formatCurrency(calculateTotals().grandTotal - calculateTotals().ivaValue)}</span>
                </div>

                {/* IVA Section */}
                <div className="totals-row-percentage" style={{ marginTop: "12px" }}>
                  <span className="totals-label">IVA</span>
                  <div className="percentage-value-group">
                    <div className="percentage-group">
                      <input
                        type="number"
                        className="percentage-small-input"
                        value={ivaPercentage}
                        onChange={(e) => handlePercentageChange(e.target.value, setIvaPercentage)}
                        disabled={isReadOnly || (!is_edit && !is_new)}
                      />
                      <span className="percentage-symbol">%</span>
                    </div>
                    <span className="percentage-currency-value">{formatCurrency(calculateTotals().ivaValue)}</span>
                  </div>
                </div>

                {/* Buttons */}
                {!isReadOnly && (
                  <div className="totals-buttons-group">
                    <button
                      className={`btn-guardar ${internalStatus === "saved" ? "btn-guardar--current" : ""}`}
                      onClick={() => saveOrder("saved")}
                    >
                      Guardar
                    </button>
                    <button
                      className={`btn-guardar-borrador ${internalStatus === "draft" ? "btn-guardar--current" : ""}`}
                      onClick={() => saveOrder("draft")}
                    >
                      Guardar Borrador
                    </button>
                  </div>
                )}

                <div className="totals-actions">
                  <button className="btn-action">
                    <FontAwesomeIcon icon={faFilePdf} />
                    <span>PDF</span>
                  </button>
                  <button className="btn-action">
                    <FontAwesomeIcon icon={faFileExcel} />
                    <span>Excel</span>
                  </button>
                </div>

                {!isReadOnly && (
                  <button className="btn-duplicate">
                    <FontAwesomeIcon icon={faCopy} />
                    <span>Duplicar BOM</span>
                  </button>
                )}
              </div>
            </div>
          </div>
          </div>
        )}

        {activeTab === 'apus' && (
          <div className="bom-empty-state">
            <div className="empty-state-icon">
              <FontAwesomeIcon icon={faBox} size="3x" color="#ccc" />
            </div>
            <h3 className="empty-state-title">APUs - Análisis de Precios Unitarios</h3>
            <p className="empty-state-description">
              Selecciona APUs predefinidos para cargar automáticamente la composición de materiales, mano de obra y costos indirectos.
            </p>
            <div className="empty-state-message">
              <p className="empty-state-coming-soon">Funcionalidad APUs próximamente</p>
              <p className="empty-state-subtext">Esta funcionalidad se implementará para cargar composiciones predefinidas</p>
            </div>
          </div>
        )}

        {activeTab === 'historico' && (
          <HistoryTab
            token={token}
            dispatch={dispatch}
            formatCurrency={formatCurrency}
            loadFromHistory={loadFromHistory}
            duplicateFromHistory={duplicateFromHistory}
          />
        )}

        {activeTab === 'productos' && !isProductMode && (
          <ProductsTab
            token={token}
            dispatch={dispatch}
            formatCurrency={formatCurrency}
            duplicateFromProduct={duplicateFromProduct}
          />
        )}
      </div>
    </>
  );
}

export default BillOfMaterials;
